import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { toast } from 'react-toastify'
import Select from 'react-select'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { FaSave, FaSpinner } from 'react-icons/fa'
import 'react-toastify/dist/ReactToastify.css'
import './CreateEmployee.css'
import API_BASE_URL from '../../../config/api'

const roleOptions = [
  { value: 'hr', label: 'HR' },
  { value: 'hod', label: 'HOD' },
  { value: 'employee', label: 'Employee' },
  { value: 'coo', label: 'COO' },
  { value: 'supervisor', label: 'Supervivsor' }
]

const CreateEmployee = () => {
  const baseUrl = API_BASE_URL
  const [departments, setDepartments] = useState([])
  const [loading, setLoading] = useState(false)
  const [fetchingDepartments, setFetchingDepartments] = useState(true)
  const [form, setForm] = useState({
    email: '',
    role: null,
    code: '',
    first_name: '',
    last_name: '',
    department: null,
    secondary_department: null,
    national_id: '',
    position: '',
    occupation: ''
  })

  useEffect(() => {
    const fetchDepartments = async () => {
      setFetchingDepartments(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/departments/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        setDepartments(response.data)
      } catch (err) {
        toast.error('Failed to fetch departments.')
      } finally {
        setFetchingDepartments(false)
      }
    }
    fetchDepartments()
  }, [])

  // Update departmentOptions to include cost center name in label
  const departmentOptions = departments.map(dep => ({
    value: dep.id,
    label: dep.course_center_name ? `${dep.name} (${dep.course_center_name})` : dep.name
  }))

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  const handleSelectChange = (selected, { name }) => {
    setForm({ ...form, [name]: selected })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const token = Cookies.get('token')
      await axios.post(`${baseUrl}/api/employees/`, {
        email: form.email,
        role: form.role?.value,
        code: form.code,
        first_name: form.first_name,
        last_name: form.last_name,
        department: form.department?.value,
        secondary_department: form.secondary_department?.value,
        national_id: form.national_id,
        position: form.position,
        occupation: form.occupation
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      toast.success('Employee created successfully!')
      setForm({
        email: '',
        role: null,
        code: '',
        first_name: '',
        last_name: '',
        department: null,
        secondary_department: null,
        national_id: '',
        position: '',
        occupation: ''
      })
    } catch (err) {
      console.log(err)
      toast.error(err.response?.data?.code[0] || 'Failed to create employee.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="create-employee-container">

        <div className="wrapper">
          <div className="employee-form-container">
            <div style={{ marginBottom: '10px' }} className="title">
              <h3>Create Employee</h3>
              <br />
            </div>
            <form onSubmit={handleSubmit} className="employee-form">
              <div className="form-row">
                <div className="form-grou">
                  <label>Email <span className="required">*</span></label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-grou">
                  <label>Role <span className="required">*</span></label>
                  <Select
                    name="role"
                    value={form.role}
                    onChange={handleSelectChange}
                    options={roleOptions}
                    placeholder="Select role"
                    classNamePrefix="react-select"
                    isDisabled={loading}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-grou">
                  <label>Code <span className="required">*</span></label>
                  <input
                    type="text"
                    name="code"
                    value={form.code}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-grou">
                  <label>Primary Department <span className="required">*</span></label>
                  <Select
                    name="department"
                    value={form.department}
                    onChange={handleSelectChange}
                    options={departmentOptions}
                    placeholder={fetchingDepartments ? 'Loading departments...' : 'Select department'}
                    classNamePrefix="react-select"
                    isDisabled={loading || fetchingDepartments}
                  />
                </div>
                {form.role?.value === 'hod' && <div className="form-grou">
                  <label>Secondary Department (Optional) <span className="required"></span></label>
                  <Select
                    name="secondary_department"
                    value={form.secondary_department}
                    onChange={handleSelectChange}
                    options={departmentOptions}
                    placeholder={fetchingDepartments ? 'Loading departments...' : 'Select department'}
                    classNamePrefix="react-select"
                    isDisabled={loading || fetchingDepartments}
                  />
                </div>}
                
              </div>
              <div className="form-row">
                <div className="form-grou">
                  <label>First Name <span className="required">*</span></label>
                  <input
                    type="text"
                    name="first_name"
                    value={form.first_name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-grou">
                  <label>Last Name <span className="required">*</span></label>
                  <input
                    type="text"
                    name="last_name"
                    value={form.last_name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-grou">
                  <label>National ID <span className="required">*</span></label>
                  <input
                    type="text"
                    name="national_id"
                    value={form.national_id}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
                <div className="form-grou">
                  <label>Position <span className="required">*</span></label>
                  <input
                    type="text"
                    name="position"
                    value={form.position}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-grou">
                  <label>Occupation <span className="required">*</span></label>
                  <input
                    type="text"
                    name="occupation"
                    value={form.occupation}
                    onChange={handleChange}
                    required
                    className="form-input"
                    disabled={loading}
                  />
                </div>
              </div>
              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-button"
                  disabled={loading || !form.email || !form.role || !form.code || !form.first_name || !form.last_name || !form.department || !form.national_id || !form.position || !form.occupation}
                >
                  {loading ? (
                    <>
                      <span>Creating Employee...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Create Employee</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateEmployee
